<template>
  <div class="blog-page">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">知予 AI</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/profit">盈利模式</router-link>
          <router-link to="/services">产品服务</router-link>
          <router-link to="/blog" class="active">心理科普</router-link>
          <router-link to="/about">关于我们</router-link>
        </nav>
        <div class="navbar-actions">
          <button class="btn-primary" @click="goToHome">立即体验</button>
        </div>
      </div>
    </header>

    <!-- 英雄区 -->
    <section class="blog-hero">
      <div class="container">
        <h1 class="hero-title">心理科普专栏</h1>
        <p class="hero-desc">提供科学、实用的心理健康知识，帮助你更好地了解自己</p>
      </div>
    </section>

    <!-- 文章内容 -->
    <section class="article-section">
      <div class="container">
        <div class="article-wrapper">
          <!-- 文章主体 -->
          <div class="article-content">
            <div class="article-header">
              <h2 class="article-title">如何识别和应对焦虑情绪</h2>              
            </div>
            
            <div class="article-body">
              
              <p class="article-paragraph">焦虑是一种常见的情绪反应，它可以帮助我们应对潜在的威胁和挑战。然而，当焦虑变得过度或持续时间过长时，它可能会影响我们的生活质量，甚至发展成焦虑障碍。了解如何识别和应对焦虑情绪，对维护心理健康至关重要。</p>
              
              <h3 class="article-subtitle">一、如何识别焦虑情绪</h3>
              
              <p class="article-paragraph">焦虑情绪通常表现为以下症状：</p>
              
              <ul class="article-list">
                <li><strong>身体症状</strong>：心跳加速、呼吸急促、出汗、颤抖、恶心、头晕等</li>
                <li><strong>心理症状</strong>：感到紧张、不安、恐惧、担忧、注意力不集中、易怒等</li>
                <li><strong>行为症状</strong>：回避某些情境、反复检查、寻求安慰、过度准备等</li>
              </ul>
              
              <h3 class="article-subtitle">二、应对焦虑的实用策略</h3>
              
              <h4 class="article-heading">1. 深呼吸练习</h4>
              <p class="article-paragraph">深呼吸是一种简单有效的焦虑缓解方法。尝试4-7-8呼吸法：吸气4秒，屏住呼吸7秒，呼气8秒，重复几次。</p>
              
              <h4 class="article-heading">2. 正念冥想</h4>
              <p class="article-paragraph">正念冥想可以帮助你专注于当下，减少对未来的担忧。每天花10-15分钟进行正念练习，观察自己的思绪而不评判它们。</p>
              
              <h4 class="article-heading">3. 渐进性肌肉放松</h4>
              <p class="article-paragraph">从脚趾开始，逐渐收紧和放松每个肌肉群，帮助释放身体的紧张感。</p>
              
              <h4 class="article-heading">4. 认知重构</h4>
              <p class="article-paragraph">识别并挑战消极的思维模式，用更现实、更积极的想法取代它们。例如，将"我一定会失败"改为"我会尽最大努力，无论结果如何都值得肯定"。</p>
              
              <h4 class="article-heading">5. 规律运动</h4>
              <p class="article-paragraph">运动可以释放内啡肽，改善心情。每周至少进行150分钟中等强度的有氧运动，如快走、跑步、游泳等。</p>
              
              <h4 class="article-heading">6. 健康生活方式</h4>
              <p class="article-paragraph">保持充足的睡眠，均衡的饮食，减少咖啡因和酒精的摄入，这些都有助于管理焦虑。</p>
              
              <h4 class="article-heading">7. 寻求支持</h4>
              <p class="article-paragraph">与朋友、家人分享你的感受，或寻求专业心理咨询师的帮助。有时候，说出来就已经是一种缓解。</p>
              
              <h3 class="article-subtitle">三、何时寻求专业帮助</h3>
              
              <p class="article-paragraph">如果你的焦虑症状持续存在，严重影响日常生活，或者你感到无法控制自己的担忧，建议寻求专业心理咨询或治疗。专业人士可以帮助你识别焦虑的根源，并提供更有针对性的治疗方案。</p>
              
              <div class="article-conclusion">
                <p class="article-paragraph">记住，焦虑是人类的正常情绪反应，每个人都会经历。通过学习和实践这些应对策略，你可以更好地管理焦虑，保持心理健康，享受更充实的生活。</p>
              </div>
            </div>

          </div>
          
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Blog',
  data() {
    return {
      isFavorite: false
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    toggleFavorite() {
      this.isFavorite = !this.isFavorite;
      this.$message.success(this.isFavorite ? '文章收藏成功！' : '文章取消收藏！');
    },
    shareArticle() {
      // 分享功能实现
      console.log('分享文章');
      // 这里可以添加分享逻辑
      this.$message.success('文章分享成功！');
    }
  }
}
</script>

<style scoped>
.blog-page {
  min-height: 100vh;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #9c89b8;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

.nav-links a:hover {
  color: #9c89b8;
}

.nav-links .active {
  color: #9c89b8;
  font-weight: bold;
}

.navbar-actions {
  display: flex;
  gap: 10px;
}

.btn-primary {
  background: linear-gradient(135deg, #9c89b8, #b8bedd);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(156, 137, 184, 0.3);
}

/* 英雄区 */
.blog-hero {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #f5f7fa, #e9ecef);
  text-align: center;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.hero-desc {
  font-size: 24px;
  color: #666;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* 文章内容 */
.article-section {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.article-wrapper {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.article-content {
  flex: 1;
  min-width: 300px;
  background-color: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.article-header {
  margin-bottom: 30px;
}

.article-category {
  display: inline-block;
  background-color: #f0f0f0;
  color: #9c89b8;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 15px;
}

.article-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #999;
}

.article-author {
  display: flex;
  align-items: center;
  gap: 10px;
}

.article-author img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.article-body {
  margin-bottom: 40px;
}

.article-image {
  margin-bottom: 30px;
  border-radius: 10px;
  overflow: hidden;
}

.article-image img {
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.article-image:hover img {
  transform: scale(1.02);
}

.article-paragraph {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.8;
}

.article-subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-top: 40px;
  margin-bottom: 20px;
}

.article-heading {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-top: 30px;
  margin-bottom: 15px;
}

.article-list {
  margin-bottom: 20px;
  padding-left: 20px;
}

.article-list li {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #666;
}

.article-conclusion {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  margin-top: 40px;
}

.article-actions {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: transparent;
  border: 1px solid #f0f0f0;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background-color: #f0f0f0;
  color: #9c89b8;
}

/* 作者介绍 */
.author-section {
  width: 300px;
  flex-shrink: 0;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.author-profile {
  background-color: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.author-profile img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 20px;
}

.author-name {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.author-title {
  font-size: 16px;
  color: #9c89b8;
  margin-bottom: 15px;
}

.author-bio {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.author-expertise {
  font-size: 14px;
  color: #999;
  line-height: 1.6;
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 40px 0;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.footer-logo {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.footer-links {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-links a {
  text-decoration: none;
  color: #ccc;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.footer-copyright {
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 10px;
  }
  
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .article-wrapper {
    flex-direction: column;
  }
  
  .author-section {
    width: 100%;
  }
  
  .article-content {
    padding: 30px;
  }
  
  .article-title {
    font-size: 24px;
  }
  
  .article-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }
  
  .article-content {
    padding: 20px;
  }
  
  .article-subtitle {
    font-size: 20px;
  }
  
  .article-heading {
    font-size: 18px;
  }
}
</style>